import { FvLinkButton } from '@fv/client-components'
import type { NotificationType } from '@fv/models'

import { routes } from '@/routes'

import type { Notification } from '../queries'

const applicableTypes: NotificationType[] = [
  'doc-center:invalid-email',
  'doc-center:email-finished',
]
type Props = {
  notification: Notification
}
export const NotificationDocCenterDetails = ({ notification }: Props) => {
  if (!applicableTypes.includes(notification.notificationType)) {
    return null
  }

  if (notification.notificationType === 'doc-center:invalid-email') {
    return <p>{notification.text}</p>
  }

  return (
    <div>
      You can see the documents in{' '}
      <FvLinkButton theme="underlined" to={routes.settings('document-center')}>
        your document center.
      </FvLinkButton>
    </div>
  )
}
